import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";
import _ from "lodash";

export class ProductFilteringEntity extends BaseEntityClass {
  value: {};
  constructor(filters: {}) {
    super();
    this.type = "product-filtering";
    this.entity_version = 2;
    this.value = _.omitBy(filters, v => _.isNil(v) || (Array.isArray(v) && !v.length));
  }
}
